import { get } from 'axios'
// import store from '@/store'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

//get
function getPostulantCalendar (pPostulantId) {
    const URI = `${BASE_URL}/api/postulants/${pPostulantId}/calendar`
    return get(URI, { headers })
}

export { getPostulantCalendar }